export const PAISES = {
  'colombia': 'co', 'méxico': 'mx', 'mexico': 'mx', 'españa': 'es', 'espana': 'es',
  'estados unidos': 'us', 'argentina': 'ar', 'chile': 'cl', 'perú': 'pe', 'peru': 'pe',
  'venezuela': 've', 'ecuador': 'ec', 'bolivia': 'bo', 'paraguay': 'py', 'uruguay': 'uy',
  'brasil': 'br', 'brazil': 'br', 'cuba': 'cu', 'costa rica': 'cr', 'panamá': 'pa',
  'panama': 'pa', 'guatemala': 'gt', 'honduras': 'hn', 'nicaragua': 'ni',
  'el salvador': 'sv', 'república dominicana': 'do', 'puerto rico': 'pr',
  'alemania': 'de', 'francia': 'fr', 'italia': 'it', 'portugal': 'pt',
  'reino unido': 'gb', 'canada': 'ca', 'canadá': 'ca', 'china': 'cn', 'japón': 'jp',
  'japon': 'jp', 'corea del sur': 'kr', 'india': 'in', 'rusia': 'ru',
};

export function codigoPais(nombre) {
  if (!nombre) return null;
  return PAISES[nombre.toLowerCase().trim()] || null;
}
